import TIPO_ADJUNTO from '../lib/adjuntos.enum';
import getBase64FromUrl from './base64Utils';

/**
 *
 * @param {string} fileName
 */
const getFileType = (fileName) => {
  if (fileName.includes('.mp3')) {
    return TIPO_ADJUNTO.MP3;
  }
  if (fileName.includes('.pdf')) {
    return TIPO_ADJUNTO.PDF;
  }
  if (fileName.includes('.png')) {
    return TIPO_ADJUNTO.PNG;
  }
  if (fileName.includes('.jpg')) {
    return TIPO_ADJUNTO.JPG;
  }
  return null;
};

/**
 *
 * @param {string} fileName
 * @returns
 */
const getFileIcon = (fileName) => {
  if (getFileType(fileName) === TIPO_ADJUNTO.MP3) {
    return 'audio';
  }
  if (getFileType(fileName) === TIPO_ADJUNTO.PDF) {
    return 'pdfDuotone';
  }
  if ([TIPO_ADJUNTO.PNG, TIPO_ADJUNTO.JPG].some((type) => type === getFileType(fileName))) {
    return 'image';
  }
  return 'file';
};

const blobToBase64 = async (blob) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

const getFileFromUrl = async (url) => {
  const { status, data: response } = await url();
  if (status === 200) {
    const urlDownLoad = URL.createObjectURL(response);
    const doc = await getBase64FromUrl(urlDownLoad);
    return `data:application/pdf;base64,${doc}`;
  }
  return undefined;
};

export { blobToBase64, getFileIcon, getFileType, getFileFromUrl };
